import React from 'react'
// @ts-ignore
import { WordCloud } from '@netbasequid/chart'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { useDisplayTheme } from '../../../hooks/useUiState'

interface WordCloudChartProps {
  data: {
    text: string
    value: number
    color: string | undefined
    custom: InsightData
  }[]
  color: string | undefined
  onClick?: (targetRow: any) => void
}

// TODO: split this chart into 2 charts: one for palette-based word cloud chart, another for color-settings-based word cloud chart.
const WordCloudChart = ({ data, color, onClick }: WordCloudChartProps) => {
  const theme = useDisplayTheme()

  const paletteColor =
    color &&
    {
      PANDORA: 'water',
      REVEAL: 'water',
      SALTILLO: 'sunrise',
      COWBOY: 'sunrise',
      SORBET: 'sunrise',
      THE_KISS: 'sunrise',
      AUTUMN_SUN: 'sunrise',
      BOOM_TSCHAK: 'tropical',
      FROST_DAWN: 'tropical',
      HINT_OF_MONET: 'tropical',
      QUIET_AND_SHY: 'citrus',
      SALMON: 'citrus'
    }[color]

  return (
    <WordCloud
      mode={theme}
      data={data}
      paletteColor={paletteColor}
      twemojiUsage
      onClick={onClick}
    />
  )
}

export default WordCloudChart
